import React from 'react';
const customStyles = {
    control: (base, state) => ({
        ...base,
        border: '0',
        background: '#d8f5f3',
        borderRadius: '10px',
        color: '#65d3c7',
        // This line disable the blue border
        boxShadow: '0 !important',
        cursor: 'pointer'
    }),
    singleValue: (base) => ({
        color: '#65d3c7',
        fontSize: '17px',
        fontStyle: 'normal',
        fontWeight: 'bold',
    }),
    option: (base, state) => ({
        ...base,
        textAlign: 'left',
        color: state.isSelected ? '#ffffff' : '#65d3c7',
        background: state.isSelected ? '#65d3c7' : 'initial',

        fontStyle: 'normal',
        fontWeight: 'bold',
        cursor: 'pointer',
        '&:active': {
            background: '#d8f5f3',
            color: '#ffffff'
        },
        '&:hover': {
            background: state.isSelected ? '#65d3c7' : '#d8f5f3',
            color: state.isSelected ? '#ffffff' : '#65d3c7'
        }
    }),

    menuList: (base) => ({
        borderRadius: '4px',
        paddingTop: '0',
        overflow: 'hidden'
    }),
    indicatorSeparator: (base) => ({
        display: 'none',

    })
}
const DropdownIndicator = () => {
    return (
        <span className="react-select-arrow">
            <i className="fa fa-angle-down" aria-hidden="true"></i>
        </span>
    );
};

const toastOptions = {
    autoClose: 3000,
    hideProgressBar: true
};
const customStylesModal = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(145, 145, 145, 0.75)',
      zIndex: '9999'
    },
  
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      zIndex: '9999',
      width: '80%',
      maxWidth: '500px',
      padding:0
    }
  };
export {
    customStyles,
    DropdownIndicator,
    toastOptions,
    customStylesModal
}


// WEBPACK FOOTER //
// ./src/components/shared/selectStyle.js